module.exports = __webpack_public_path__ + "static/media/pin_grin.1e144280.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_grin.svg
// module id = 1271
// module chunks = 0